<template>
    <div>
        <label class="label-control" v-if="showLabel" for="form-employee">Pracownik:</label>
        <vs-select autocomplete v-model="employee" id="form-employee">
            <vs-select-item :key="item" :value="item" :text="item" v-for="item in getFilteredEmployeeNames()" />
        </vs-select>
    </div>
</template>

<script>
    import {backend} from '../backend';

    import Vue from 'vue';
    import Vuesax from 'vuesax';

    Vue.use(Vuesax);

    export default {
        name: 'SelectEmployee',
        data() {
            return {
                employees: [],
                employee: this.defaultEmployee || '',
            }
        },
        props: {
            formInputResetFlag: Boolean,
            filter: Function,
            defaultEmployee: String,
            prefetchedEmployees: Array,
            showLabel: {
                type: Boolean,
                default: true,
            },
            placeholder: {
                type: String,
                default: '',
            },
            required: {
                type: Boolean,
                default: true,
            }
        },
        created() {
            if (this.prefetchedEmployees) {
                this.employees = this.prefetchedEmployees;
            } else {
                backend.getEmployees()
                    .then((response) => {
                        this.employees = response.data;
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy pracowników.', color: 'danger'});
                    });
            }
        },
        watch: {
            employee() {
                let emp = this.employees.find((el) => {
                    return el.username === this.employee;
                }) || '';

                this.$emit('name', emp ? emp.username : this.placeholder);
                this.$emit('id', emp ? emp.id : '');
                this.$emit('company', emp ? emp.company.name : '');
                this.$emit('remote_user', emp ? emp.remote_user : '');
            },
            formInputResetFlag() {
                if (this.required && this.defaultEmployee !== undefined) {
                    this.employee = this.defaultEmployee;
                } else {
                    this.employee = this.placeholder;
                }
            }
        },
        methods: {
            getFilteredEmployeeNames() {
                let names = this.filter ? this.filter(this.employees) : this.employees.map(emp => emp.username);
                if (this.required == false || this.defaultEmployee === undefined)
                    names.unshift(this.placeholder);
                else if (names.indexOf(this.defaultEmployee) < 0)
                    names.unshift(this.defaultEmployee);
                return names;
            },
        }
    }
</script>

<!-- must not be scoped as otherwise vs-select cannot apply this CSS rule -->
<style lang="css">
    .input-select {
        width: 100%;
    }
    #form-employee {
        color: black;
    }
</style>



// WEBPACK FOOTER //
// SelectEmployee.vue?121ca660